export enum UserTypeSelection {
    EXISTING = 'EXISTING',
    NEW = 'NEW',
}
